import PoliceCentralUserInfo from "@/pages/Users/sections/PoliceCentralUserInfo";

const StaffPoliceCentralUserInfo = ({ startingPoint = "", policeCentralUserRef } = {}) => {
    return(
        <>
        <PoliceCentralUserInfo startingPoint={startingPoint} policeCentralUserRef={policeCentralUserRef} />
        </>
    )
}
export default StaffPoliceCentralUserInfo;